class MainProduct extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.updateCartCount();
    this.initializeForm();
    this.handleSwiper();
    this.zoomImage();

    this.productAddedContainer = this.querySelector(".main-product__product-added-msg");
    this.productAddedMessage = this.querySelector(".main-product__product-added");
    this.productAddedIcon = this.querySelector(".main-product__check-icon");
    this.loaderIocnAnimation = this.querySelector(".main-product__loader-icon");
    this.submitFormBtn = this.querySelector(".product__submit");
    this.tabNavigation = this.querySelectorAll(".content-tabs__nav li");
    this.productName = this.getAttribute("data-product-name");
  }

  initializeForm() {
    const form = this.querySelector("#main-product-form");
    const quantityInput = this.querySelector("#product-quantity");
    const increaseButton = this.querySelector("#increase-quantity");
    const decreaseButton = this.querySelector("#decrease-quantity");
    const variantId = this.getAttribute("data-variant-id");

    if (form) {
      form.addEventListener("submit", (submitEvent) => {
        submitEvent.preventDefault();
        const quantity = parseInt(quantityInput.value);
        this.addToCart(parseInt(variantId), quantity);
      });
    }

    quantityInput.value = 1;

    increaseButton.addEventListener("click", () => {
      quantityInput.value = parseInt(quantityInput.value) + 1;
    });

    decreaseButton.addEventListener("click", () => {
      if (quantityInput.value > 1) {
        quantityInput.value = parseInt(quantityInput.value) - 1;
      }
    });
  }

  addToCart(variantId, quantity) {
    this.submitFormBtn.setAttribute("disabled", "");
    this.showLoadingSpinner();

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity,
          },
        ],
      }),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        this.productAdded();
        this.hideLoadingSpinner();
        return response.json();
      })
      .then(() => {
        this.updateCartCount();
      })
      .catch((error) => {
        console.error("Error adding product to cart:", error);
      });
  }

  updateCartCount() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const cartCountBubble = document.querySelector(".cart-count-bubble");
        cartCountBubble.innerText = cart.item_count;
        cartCountBubble.style.display = cart.item_count > 0 ? "flex" : "none";
      })
      .catch((error) => {
        console.error("Error fetching cart count:", error);
      });
  }

  productAdded() {
    this.productAddedContainer.classList.add("show");
    this.productAddedMessage.innerHTML = `${this.productName} has been added to the cart`;
    
    this.productAddedIcon.style.display = "block";

    setTimeout(() => {
      this.productAddedIcon.style.display = "none";
    }, 1000);
  }

  showLoadingSpinner() {
    this.productAddedIcon.style.display = "none";
    this.loaderIocnAnimation.style.display = "flex";
  }

  hideLoadingSpinner() {
    this.submitFormBtn.removeAttribute("disabled");
    this.loaderIocnAnimation.style.display = "none";
  }

  zoomImage() {
    const zoomContainers = this.querySelectorAll(".zoom-container");
    zoomContainers.forEach((zoomContainer) => {
      const zoomImage = zoomContainer.querySelector(".zoom-image");

      zoomContainer.addEventListener("mousemove", (e) => {
        const rect = zoomContainer.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const xPercent = (x / zoomContainer.offsetWidth) * 100;
        const yPercent = (y / zoomContainer.offsetHeight) * 100;

        zoomImage.style.transformOrigin = `${xPercent}% ${yPercent}%`;
        zoomImage.style.transform = `scale(2)`;
      });

      zoomContainer.addEventListener("mouseleave", () => {
        zoomImage.style.transformOrigin = "center center";
        zoomImage.style.transform = "scale(1)";
      });
    });
  }

  handleSwiper() {
    document.addEventListener("DOMContentLoaded", () => {
      this.swiper = new Swiper(".main-product__swiper", {
        loop: false,
        autoplay: false,
      });

      this.addSmallImageClickListeners();
    });
  }

  addSmallImageClickListeners() {
    const smallImages = document.querySelectorAll(".main-product__small-image");

    smallImages.forEach((element, index) => {
      element.addEventListener("click", () => {
        this.swiper.slideTo(index);
      });
    });
  }
}

customElements.define("main-product", MainProduct);
